import { useState, useEffect } from 'react';
import { GetLoggedInUserDetails } from '../queries/appQueries';


const usePermissionCheck = () => {
  const [isValid, setIsValid] = useState(true);

   const { data: userDetails = [], isLoading: isUserDetailsLoading }=GetLoggedInUserDetails()

  useEffect(() => {
   
   if(userDetails?.data?.role_details?.map(item=>item.access_level).includes('No permission'))
   {
   return  setIsValid(true)
   }
     if(userDetails?.data?.role_details?.map(item=>item.access_level).length===0)
   {
    return setIsValid(true)
   }
       if(!userDetails?.data?.role_details?.map(item=>item.access_level))
   {
  return  setIsValid(true)
   }

   setIsValid(false)

  }, [isUserDetailsLoading,userDetails]);

  return {isAccessLoading:isUserDetailsLoading,access:isValid};
};

export default usePermissionCheck;
